<template>
    <a href="#" class="ec-compare-button" :class="{'active': active}" title="Comparer ce vélo"
       @click="toggleComparison()">
        <i class="ec-icon ec-icon-compare"></i>
    </a>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-compare-button {
        padding: $grid-gutter-width/2 $grid-gutter-width/2;
        background: $ec-bike-info-foreground;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        @include ec-flex-center();

        .ec-icon {
            color: $ec-color-white;
            font-size: $ec-icon-height-small;
        }

        &:hover, &.active {
            background: $ec-primary-color;
        }
    }
</style>

<script type="text/babel">
    let compareButton = require('./mixins/CompareButton.js');

    export default {
        mixins: [compareButton]
    }
</script>